export const tempoProjectsPageSizeOptions = [
    {
        value: 10,
        label: '10',
    },
    {
        value: 25,
        label: '25',
    },
    {
        value: 50,
        label: '50',
    },
]

export const tempoInitialFilterState = {
    name: '',
    sourceLanguages: [],
    targetLanguages: [],
    priceMin: '',
    priceMax: '',
    status: '',
    startDateFromTo: { to: null, from: null },
    deadlineFromTo: { to: null, from: null },
}

export const tempoInitialTerminologyFilterState = {
    sourceLanguage: '',
    targetLanguage: '',
    collection: '',
    content: '',
}

export const tempoInitialValidationFilterState = {
    validators: '',
    status: '',
    responsibles: '',
    projectName: '',
    showLate: false,
}
